import AppLayout from "@/components/AppLayout";
import PageHeader from "@/components/PageHeader";
import { EmptyState } from "@/components/LoadingState";

// Placeholder — wiring system-wide audit (no org filter) would require an additional backend route.
// For the initial build we surface the same per-org audit log via the staff sidebar's organisation pages.
export default function SystemAuditLogPage() {
  return (
    <AppLayout>
      <PageHeader title="System audit" subtitle="Cross-organisation event stream" />
      <EmptyState
        title="Coming soon"
        hint="View per-organisation audit logs by opening an organisation from the list."
      />
    </AppLayout>
  );
}
